module.exports = __webpack_public_path__ + "img/badge_economy.c8a311f0.png";